import React, { useState, useEffect } from "react";
import { TimePickerProps } from "./TimePicker.types";
import {
  Container,
  Title,
  TimeDisplay,
  Separator,
  LabelRow,
  TimeBlock,
  Text,
  Button,
  TimeInput,
} from "./TimePicker.styles";

const TimePicker: React.FC<TimePickerProps> = ({ value = "00:00", onChange }) => {
  const [time, setTime] = useState(value);
  useEffect(() => {
    const formattedTime = time;
    // Вызываем onChange только если новое значение отличается от текущего prop value
    if (formattedTime !== value && onChange) {
      onChange(formattedTime);
    }
  }, [time, onChange, value]);

  // Пример обработки кликов и прокрутки для изменения часов и минут
  const incrementHours = () => {
    setTime((prev) => {
      const [h, m] = prev.split(":").map(Number);
      const newH = (h + 1) % 24;
      return `${String(newH).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    });
  };

  const decrementHours = () => {
    setTime((prev) => {
      const [h, m] = prev.split(":").map(Number);
      const newH = (h - 1 + 24) % 24;
      return `${String(newH).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    });
  };

  const incrementMinutes = () => {
    setTime((prev) => {
      const [h, m] = prev.split(":").map(Number);
      const newM = (m + 1) % 60;
      return `${String(h).padStart(2, "0")}:${String(newM).padStart(2, "0")}`;
    });
  };

  const decrementMinutes = () => {
    setTime((prev) => {
      const [h, m] = prev.split(":").map(Number);
      const newM = (m - 1 + 60) % 60;
      return `${String(h).padStart(2, "0")}:${String(newM).padStart(2, "0")}`;
    });
  };

  const handleWheel = (event: React.WheelEvent, type: "hours" | "minutes") => {
    if (event.deltaY < 0) {
      type === "hours" ? incrementHours() : incrementMinutes();
    } else {
      type === "hours" ? decrementHours() : decrementMinutes();
    }
  };

  return (
    <Container>
      <Title>Время</Title>
      <TimeDisplay>
        <TimeBlock>
          <Button onClick={incrementHours}>▲</Button>
          <TimeInput
            onWheel={(e) => handleWheel(e, "hours")}
            style={{ cursor: "ns-resize", userSelect: "none", padding: "0 10px" }}
          >
            {time.split(":")[0]}
          </TimeInput>
          <Button onClick={decrementHours}>▼</Button>
          <Text>часы</Text>
        </TimeBlock>
        <Separator>:</Separator>
        <TimeBlock>
          <Button onClick={incrementMinutes}>▲</Button>
          <TimeInput
            onWheel={(e) => handleWheel(e, "minutes")}
            style={{ cursor: "ns-resize", userSelect: "none", padding: "0 10px" }}
          >
            {time.split(":")[1]}
          </TimeInput>
          <Button onClick={decrementMinutes}>▼</Button>
          <Text>минуты</Text>
        </TimeBlock>
      </TimeDisplay>
      <LabelRow />
    </Container>
  );
};

export default TimePicker;
